import { IWobGliderBaseConstParam, WobGliderBase } from '@/models/wob//WobGliderBase'

export interface IWobGliderModConfConstParam extends IWobGliderBaseConstParam {
  modKey: string | null
  modIrisConf: any
}

export class WobGliderModConf extends WobGliderBase {
  public modKey: string | null
  public modIrisConf: any

  constructor({ modKey,modIrisConf, ...args }: IWobGliderModConfConstParam) {
    super(args)
    this.modKey = modKey
    this.modIrisConf = modIrisConf
  }
}
